<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="wlsq-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <!-- search -->
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="信息类型">
              <el-select v-model="searchForm.type" style="width: 100px" filterable clearable @keyup.enter.native="search">
                <el-option label="投诉" :value="0" />
                <el-option label="建议" :value="1" />
                <!-- <el-option label="举报" :value="2" /> -->
                <el-option label="表扬" :value="3" />
                <el-option label="留言" :value="4" />
              </el-select>
            </el-form-item>
            <el-form-item label="处理状态">
              <el-select v-model="searchForm.status" style="width: 120px" filterable clearable @keyup.enter.native="search">
                <el-option label="待审核" :value="0" />
                <el-option label="待处理" :value="1" />
                <el-option label="进行中" :value="2" />
                <el-option label="已处理" :value="3" />
                <el-option label="未解决" :value="4" />
                <el-option label="已解决" :value="5" />
                <el-option label="已关闭" :value="6" />
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <!-- <el-form-item style="float: right">
              <el-button type="primary" class="add-btn" icon="el-icon-plus" @click="getData()">添加</el-button>
            </el-form-item> -->
          </el-form>
          <!-- table -->
          <div class="card-content">
            <el-table
              v-loading="dataLoading"
              :data="tableData"
              stripe
              style="width: 100%"
            >
              <el-table-column
                label="序号"
                type="index"
                width="50"
              >
              </el-table-column>
              <el-table-column
                label="类型"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.type===0" type="danger">投诉</el-tag>
                  <el-tag v-if="scope.row.type===1" type="warning">建议</el-tag>
                  <el-tag v-if="scope.row.type===2">举报</el-tag>
                  <el-tag v-if="scope.row.type===3" type="success">表扬</el-tag>
                  <el-tag v-if="scope.row.type===4" type="info">留言</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                label="客户昵称"
                width="100"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.username }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="投诉对象"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button v-if="scope.row.relatedType===0" icon="el-icon-s-order" size="mini" @click="toOrderDetail(scope.row.orderId)">关联订单</el-button>
                  <el-button v-if="scope.row.relatedType===1" icon="el-icon-s-custom" size="mini" @click="toDealerDetail(scope.row.relatedId)">关联经销商</el-button>
                </template>
              </el-table-column>
              <el-table-column
                label="投诉问题"
                width="120"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.problems }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="核心诉求"
                width="170"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.needs }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="内容"
                min-width="200"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="提交时间"
                min-width="180"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createTime }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="处理状态"
                width="120"
                fixed="right"
                align="center"
              >
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                      待审核：信息待平台审核<br>
                      待处理：信息已审核通过，待回复<br>
                      进行中：信息已回复，正与客户交流互动<br>
                      已处理：信息已处理，待客户确认是否解决<br>
                      未解决：客户不认可处理结果，须继续处理<br>
                      已解决：信息处理结果已被客户认可<br>
                      已关闭：信息处理被平台或客户进行关闭，无法再次进行交流互动<br>
                    </div>
                    <el-tag v-if="scope.row.status===0" type="danger">待审核</el-tag>
                    <el-tag v-if="scope.row.status===1" type="danger">待处理</el-tag>
                    <el-tag v-if="scope.row.status===2" type="warning">进行中</el-tag>
                    <el-tag v-if="scope.row.status===3">已处理</el-tag>
                    <el-tag v-if="scope.row.status===4" type="danger">未解决</el-tag>
                    <el-tag v-if="scope.row.status===5" type="success">已解决</el-tag>
                    <el-tag v-if="scope.row.status===6" type="info">已关闭</el-tag>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                width="160"
                fixed="right"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <el-button icon="el-icon-document" size="mini" @click="showEdit(scope.row.id)">详情</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="total > 0"
              background
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 处理 -->
    <el-dialog
      title="详情信息"
      :visible.sync="editVisible"
      width="850px"
      top="10vh"
      center
      :before-close="closeDialog"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true"
    >
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="150px" size="mini">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称：" prop="username">
              <span>{{ editForm.username }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="客户电话：" prop="userTel">
              <span>{{ editForm.userTel }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="信息类型:" prop="type">
              <el-tag v-if="editForm.type===0" type="danger">投诉（{{ editForm.category }}）</el-tag>
              <el-tag v-if="editForm.type===1" type="warning">建议（{{ editForm.category }}）</el-tag>
              <el-tag v-if="editForm.type===2">举报</el-tag>
              <el-tag v-if="editForm.type===3" type="success">表扬</el-tag>
              <el-tag v-if="editForm.type===4" type="info">留言</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处理状态：" prop="status">
              <el-tag v-if="editForm.status===0" type="danger">待审核</el-tag>
              <el-tag v-if="editForm.status===1" type="danger">待处理</el-tag>
              <el-tag v-if="editForm.status===2" type="warning">进行中</el-tag>
              <el-tag v-if="editForm.status===3">已处理</el-tag>
              <el-tag v-if="editForm.status===4" type="danger">未解决</el-tag>
              <el-tag v-if="editForm.status===5" type="success">已解决</el-tag>
              <el-tag v-if="editForm.status===6" type="info">已关闭</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="editForm.type===0">
          <el-col :span="24">
            <el-form-item label="投诉对象：" prop="createTime">
              <span v-if="editForm.relatedType === 0">
                <span v-if="editForm.orderType === 0">正单</span>
                <span v-if="editForm.orderType === 1">客改单</span>
                <span v-if="editForm.orderType === 2">增补单</span>
                <span v-if="editForm.orderType === 3">色板单</span>
                <span v-if="editForm.orderType === 4">售后单</span>
                <span style="color:rgb(15, 119, 246); cursor:pointer;" @click="toOrderDetail(editForm.orderId)"> {{ editForm.orderNum }}</span>
                <span>（{{ editForm.orderAddress }}）</span>
              </span>
              <span v-if="editForm.relatedType === 1">经销商
                <span style="color:rgb(15, 119, 246); cursor:pointer;" @click="toDealerDetail(editForm.relatedId)"> {{ editForm.dealerName }}</span>
                ({{ editForm.dealerTel }})
              </span>
              <span v-if="editForm.relatedType === 2">其他({{ editForm.relatedId }})</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="editForm.type===3">
          <el-col :span="24">
            <el-form-item label="表扬对象：" prop="createTime">
              <span v-if="editForm.relatedType === 1">经销商
                <span style="color:rgb(15, 119, 246); cursor:pointer;" @click="toDealerDetail(editForm.relatedId)"> {{ editForm.dealerName }}</span>
                ({{ editForm.dealerTel }})
              </span>
              <span v-if="editForm.relatedType === 2">其他({{ editForm.relatedId }})</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="editForm.type===0">
          <el-col :span="12">
            <el-form-item label="投诉问题：" prop="problems">
              <span>{{ editForm.problems }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="核心诉求：" prop="needs">
              <span>{{ editForm.needs }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="提交内容：" prop="remark">
              <span>{{ editForm.remark }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="提交时间：" prop="createTime">
              <span>{{ editForm.createTime }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="editForm.auditTime != null" label="审核时间:" prop="auditTime">
              <span>{{ editForm.auditTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item v-if="editForm.startTime != null" label="开始处理时间：" prop="startTime">
              <span>{{ editForm.startTime }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="editForm.endTime != null" label="处理完成时间：" prop="endTime">
              <span>{{ editForm.endTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item v-if="editForm.confirmTime != null" label="客户确认时间：" prop="confirmTime">
              <span>{{ editForm.confirmTime }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="editForm.status < 5 && editForm.status != 3">
          <el-row>
            <el-col :span="24">
              <el-form-item label="回复内容 " prop="content">
                <el-autocomplete
                  v-model="editForm.content"
                  class="inline-input"
                  type="textarea"
                  style="width: 520px;"
                  placeholder="请输入内容"
                  :fetch-suggestions="querySearch"
                  placement="top"
                  :autosize="{ minRows: 4, maxRows: 10}"
                  :maxlength="200"
                  show-word-limit
                  @select="handleSelect"
                >
                  <!-- <template slot-scope="{ item }">
                    <a :title="item.value" style="text-decoration:none">{{ item.value }}</a>
                  </template> -->
                </el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="回复标签" prop="tag">
                <el-select v-model="editForm.tag" style="width: 100px" @change="$forceUpdate()">
                  <el-option v-if="editForm.status == 0 && user.delid == null" label="审核通过" :value="1" />
                  <el-option v-if="editForm.status > 0" label="已回复" :value="2" />
                  <el-option v-if="editForm.status > 0" label="已处理" :value="3" />
                  <el-option v-if="user.delid == null" label="关闭" :value="6" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="图片信息" prop="images">
                <el-upload
                  :action="baseUrl + fileUploadUrl"
                  :headers="headerObj"
                  list-type="picture-card"
                  :class="{hide: hideImgUploadEdit}"
                  :limit="8"
                  :file-list="msgImgList"
                  :before-upload="handleBeforeUpload"
                  :on-success="handlePictureSuccess"
                  :on-error="handleUploadError"
                  :on-exceed="handlePictureExceed"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handlePictureRemove"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item style="text-align: center;">
                <el-button type="primary" :loading="editBtnLoading" @click="replay('editForm')">回复</el-button>
                <el-button @click="editVisible=false">取消</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <div style="overflow-y: auto; height: 350px">
          <el-row v-for="item in editForm.tracks" :key="item.id">
            <el-col :span="24">
              <div style="display: flex;flex-direction: row;justify-content: flex-start;margin-left:50px;margin-top:20px;">
                <!-- 头像昵称 -->
                <div style="display: flex;flex: 1;flex-direction: column;justify-content: flex-start;align-items: center;">
                  <img style="width:50px;height:50px; border-radius: 25px;" :src="item.avatar">
                  <div style="margin-top:10px;">{{ item.nickname }}</div>
                </div>
                <!-- 时间内容 -->
                <div style="display: flex;flex: 5;flex-direction: column;justify-content: flex-start;margin-left:20px;">
                  <div>{{ item.createTime }}
                    <el-tag v-if="item.userType == 0">客户</el-tag>
                    <el-tag v-if="item.userType == 1">经销商</el-tag>
                    <el-tag v-if="item.userType == 2">平台</el-tag>
                  </div>
                  <div style="margin-top:10px;margin-bottom:5px;">{{ item.content }}</div>
                  <div v-if="item.urls" style="display: flex;flex-direction: row;justify-content: flex-start;">
                    <img
                      v-for="imgUrl in item.urls.split(',')"
                      :key="imgUrl"
                      style="width:120px;margin-left:5px;"
                      :src="imgUrl + thumbnail"
                      @click="picturePreview(imgUrl)"
                    >
                  </div>
                </div>
                <!-- 处理状态 -->
                <div style="display: flex;flex: 1;">
                  <span v-if="item.tag===0">
                    <el-tag v-if="editForm.type===0" type="danger">提交投诉</el-tag>
                    <el-tag v-if="editForm.type===1" type="warning">提交建议</el-tag>
                    <el-tag v-if="editForm.type===2" type="danger">提交举报</el-tag>
                    <el-tag v-if="editForm.type===3" type="success">提交表扬</el-tag>
                    <el-tag v-if="editForm.type===4">提交留言</el-tag>
                  </span>
                  <el-tag v-if="item.tag===1" type="success">审核通过</el-tag>
                  <el-tag v-if="item.tag===2" type="warning">
                    <span v-if="item.userType===0">客户补充</span>
                    <span v-if="item.userType===1">服务商回复</span>
                    <span v-if="item.userType===2">平台回复</span>
                  </el-tag>
                  <el-tag v-if="item.tag===3">已处理</el-tag>
                  <el-tag v-if="item.tag===4" type="danger">未解决</el-tag>
                  <el-tag v-if="item.tag===5" type="success">已解决</el-tag>
                  <el-tag v-if="item.tag===6" type="info">已关闭</el-tag>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="imageVisible">
      <img width="100%" :src="imageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import axios from 'axios'

export default {
  name: 'Order',
  data() {
    return {
      // 基础url
      baseUrl: 'https://www.mulu.life/prod-api',
      // baseUrl: 'http://localhost:8181',
      fileUploadUrl: '/promotion/files/upload',
      // 缩略图
      thumbnail: '?x-oss-process=image/resize,m_fill,h_100,w_100',
      // 登录参数
      loginForm: {},
      // token header
      headerObj: {
        Authorization: null
      },
      fullscreenLoading: false,
      // 查询
      dataLoading: false,
      searchForm: {
        type: null,
        status: null,
        search: null
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      // 处理
      editVisible: false,
      editBtnLoading: false,
      editRules: {
        content: [{ required: true, message: '请输入审核回复内容', trigger: 'blur' }]
      },
      editForm: {},
      // 图片列表
      msgImgList: [],
      // 上传状态
      isUploading: false,
      // 查看图片url
      imageUrl: '',
      // 是否显示图片
      imageVisible: false,
      // 回复字典
      replayDict: []
    }
  },
  computed: {
    user: getUser,
    hideImgUploadEdit() {
      return this.msgImgList.length >= 8
    }
  },
  created() {
    this.login()
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.replayDict
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1)
      }
    },
    handleSelect(it) {
      this.$refs.editForm.validateField('content')
    },
    handleBeforeUpload(file) {
      this.isUploading = true
    },
    handleUploadError(res, file, fileList) {
      this.isUploading = false
    },
    handlePictureSuccess(res, file, fileList) {
      if (res.code !== 200) {
        this.$message.error('上传图片失败，请重试')
        this.msgImgList = fileList.filter(it => it.uid !== file.uid)
        return
      }
      var fileItem = {
        uid: file.uid,
        url: res.data.url + this.thumbnail
      }
      this.msgImgList.push(fileItem)
      this.isUploading = false
    },
    handlePictureRemove(file, fileList) {
      const index = this.msgImgList.findIndex(it => it.uid === file.uid)
      if (index !== -1) {
        this.msgImgList.splice(index, 1)
      }
    },
    handlePictureCardPreview(file) {
      this.imageUrl = file.url.replace(this.thumbnail, '')
      this.imageVisible = true
    },
    handlePictureExceed(files, fileList) {
      this.$message.warning(`当前限制上传 8 张图片`)
    },
    picturePreview(url) {
      this.imageUrl = url
      this.imageVisible = true
    },
    // 登录
    login() {
      console.log(axios);
      this.dataLoading = true
      if (this.user.delid == null) {
        this.loginForm = {
          userType: 'mulu_staff_user',
          userId: this.user.dUserid,
          username: this.user.dName,
          mobile: this.user.dTel,
          avatar: this.user.dPhoto.indexOf('/elichain/static/img/photo') === -1 ? this.user.dPhoto : 'https://www.mulu.life' + this.user.dPhoto
        }
      } else {
        this.loginForm = {
          userType: 'mulu_dealer_user',
          userId: this.user.userid,
          username: this.user.delname,
          mobile: this.user.tel,
          avatar: this.user.photo.indexOf('/elichain/static/img/photo') === -1 ? this.user.photo : 'https://www.mulu.life' + this.user.photo,
          dealerId: this.user.delid
        }
      }
      axios.post(this.baseUrl + '/auth/muluLogin', this.loginForm).then(res => {
        if (res.data.code === 200) {
          this.headerObj = {
            Authorization: 'Bearer ' + res.data.data.access_token
          }
          sessionStorage.setItem('access_token', res.data.data.access_token)
          this.getData()
          this.getReplayDict()
        } else {
          this.$message.error('用户认证失败，请重试')
          this.dataLoading = false
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('用户认证失败，请重试！')
        this.dataLoading = false
      })
    },
    // 获取回复字典
    getReplayDict() {
      axios.get(this.baseUrl + '/system/dict/data/type/szs_complaint_replay', {
        headers: this.headerObj
      }).then(res => {
        if (res.data.code === 200) {
          this.replayDict = res.data.data
          if (this.user.delid != null) {
            this.replayDict = this.replayDict.filter(it => it.cssClass === '1')
          }
          this.replayDict = this.replayDict.map(item => {
            return {
              ...item,
              value: item.dictValue
            }
          })
        } else {
          this.$message.error('获取回复字典列表数据失败，请重试')
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取回复字典列表数据失败，请重试！')
      })
    },
    // 搜索
    search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = null
        this.getData()
      }
    },
    // 获取数据
    getData() {
      this.dataLoading = true
      axios.get(this.baseUrl + '/promotion/complaints/list', {
        headers: this.headerObj,
        params: {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          type: this.searchForm.type,
          status: this.searchForm.status,
          search: this.searchForm.search
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.total = res.data.total
          this.tableData = res.data.rows
        } else {
          this.$message.error('获取列表数据失败，请重试')
        }
        this.dataLoading = false
      }).catch(err => {
        console.log(err)
        this.$message.error('获取列表数据失败，请重试！')
        this.dataLoading = false
      })
    },
    // 修改页长
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    // 修改页数
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    // 跳转订单详情
    toOrderDetail(orderid) {
      if (orderid.length > 36) {
        this.$router.push({
          path: '/work/order/' + orderid.substring(0, 36),
          query: {
            data: orderid.substring(37)
          }
        })
      } else {
        this.$router.push({ path: '/work/order/' + orderid.substring(0, 36) })
      }
    },
    // 跳转经销商详情
    toDealerDetail(delid) {
      this.$router.push({ path: '/work/dealer/' + delid })
    },
    // 显示处理
    showEdit(id) {
      this.editForm = {}
      this.msgImgList = []
      axios.get(this.baseUrl + '/promotion/complaints/' + id, {
        headers: this.headerObj
      }).then(res => {
        if (res.data.code === 200) {
          this.editForm = res.data.data
          this.msgImgList = []
          this.$set(this.editForm, 'content', '')
          // 未审核默认审核通过，已审核默认已回复
          if (this.editForm.status === 0) {
            this.editForm.tag = 1
          } else {
            this.editForm.tag = 2
          }
          this.editVisible = true
        } else {
          this.$message.error('获取详情数据失败，请重试')
        }
      }).catch(err => {
        console.log(err)
        this.$message.error('获取详情数据失败，请重试！')
      })
    },
    // 关闭弹窗
    closeDialog(done) {
      this.getData()
      done()
    },
    // 回复
    replay(formName) {
      if (this.isUploading) {
        this.$message.error('请等待图片上传完成')
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editBtnLoading = true
          if (this.msgImgList.length > 0) {
            this.editForm.urls = this.msgImgList.map(it => it.url.replace(this.thumbnail, '')).join(',')
          }
          axios.put(this.baseUrl + '/promotion/complaints', this.editForm, {
            headers: this.headerObj
          }).then(res => {
            if (res.data.code === 200) {
              this.showEdit(this.editForm.id)
              this.$message.success('回复成功')
            } else if (res.data.code === 600) {
              this.$message.error(res.data.msg)
            } else {
              this.$message.error('回复失败，请重试')
            }
            this.editBtnLoading = false
          }).catch(err => {
            console.log(err)
            this.editBtnLoading = false
            this.$message.error('回复失败，请重试！')
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  // .el-form-item{
  //   margin-bottom: 8px;
  // }

  .autocomplete-input {
    width: 400px;
  }
  // 隐藏上传按钮
  ::v-deep .hide .el-upload--picture-card {
    display: none;
  }

  // 添加/删除文件时去掉动画过渡
  ::v-deep .el-upload-list__item {
    transition: none !important;
  }
.wlsq-container {
  .el-table .el-table__footer-wrapper{
    color:#409EFF;
  }
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .add-btn{
            position: relative;
            float: right;
            margin-left: 10px;
            margin-top: -10px;
          }
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
